// extracted by mini-css-extract-plugin
export default {"layout":"_0ce16edcfe _5809da8737 _16f145505e","h_slide":"_3a15996e91","category":"_22a8ffae8c f8f20f2186 ebc5b7e85f"};